import hcOffcanvasNav from "lib/hc-offcanvas-nav";
import AOS from 'aos';


window.dataLayer = window.dataLayer || [];

document.addEventListener('DOMContentLoaded', function () {
    var Nav = new hcOffcanvasNav('#main-nav', {
        disableAt: true,
        pushContent: ".site-container",
        position: 'right',
        levelOpen: 'expand'
    });

    var menuMain = document.getElementById('menu-main');
    if (menuMain) {
        document.getElementById('menu-main').innerHTML += '<a href="#" class="hc-nav-trigger hc-nav-1" role="button" aria-label="Open Menu" aria-controls="hc-nav-1" aria-expanded="false"><span></span></a>';

        document.querySelector('.hc-nav-trigger').addEventListener('click', function (event) {
            event.preventDefault(); // Prevent the default behavior of the anchor tag
            Nav.toggle();
        });

    }

    const filters = document.querySelectorAll(".tags-list a,.custom-filter a");
    const posts = document.querySelectorAll(".post-bucket");

    filters.forEach(filter => {
        filter.addEventListener("click", function (e) {
            e.preventDefault(); // Prevent the page from reloading


            const otherDropdownList = document.getElementById('dropdownListFilter');

            const selectedTag = this.getAttribute("data-filter");
            const selectedText = this.textContent; // Get the text of the clicked filter

            // Update the dropdown toggle button's text
            const dropdownToggleFilter = document.querySelector(".dropdown-toggle-filter");
            if (dropdownToggleFilter) {
                dropdownToggleFilter.innerHTML = selectedText;
                otherDropdownList.style.display = "none";
            }


            // Remove active class from all filters and add to the selected one
            filters.forEach(f => {
                f.classList.remove("selected");
                f.parentElement.classList.remove("selected"); // Remove class from parent LI
            });
            this.classList.add("selected");
            this.parentElement.classList.add("selected"); // Add class to parent LI

            posts.forEach(post => {
                // Get the data-tags attribute and split it into an array
                const postTags = post.getAttribute("data-tags")?.split(", ") || [];

                // Show or hide posts based on tag match
                if (selectedTag === "all" || postTags.includes(selectedTag)) {
                    post.style.display = "block"; // Show the post
                } else {
                    post.style.display = "none"; // Hide the post
                }
            });

            AOS.refreshHard();
        });
    });
});


$(document).ready(function () {
    $('.resource-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        once: true,
        dots: true,
        mobileFirst: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    adaptiveHeight: false,
                }
            }
        ]
    });

    function initCarousel() {
        const carousel = $('.image-carousel');
        let isInitialized = false;
        let slickInstance = null;

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // When carousel comes into view
                    if (!isInitialized) {
                        // Initialize Slick if not already done
                        carousel.slick({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: false,
                            fade: true,
                            autoplay: true
                        });
                        isInitialized = true;
                        slickInstance = carousel;
                    } else if (slickInstance) {
                        // If already initialized, reset to first slide and restart autoplay
                        slickInstance.slick('slickGoTo', 0);
                        slickInstance.slick('slickPlay');
                    }
                } else {
                    // When carousel leaves view
                    if (slickInstance) {
                        slickInstance.slick('slickPause');
                    }
                }
            });
        }, {
            threshold: 0.5 // Trigger when 50% of carousel is visible
        });

        // Observe the carousel element
        observer.observe(carousel[0]);

        // Cleanup when needed (e.g., if using in a SPA)
        return () => {
            observer.disconnect();
            if (slickInstance) {
                slickInstance.slick('unslick');
            }
        };
    }

    function initCarousel() {
        const carousel = $('.image-carousel');

        // Initialize the carousel immediately
        carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            autoplaySpeed: 1500,
            autoplay: false, // Start with autoplay disabled
            initialSlide: 0  // Start on first slide
        });

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // When carousel comes into view
                    carousel.slick('slickPlay'); // Start autoplay
                } else {
                    // When carousel leaves view
                    carousel.slick('slickPause'); // Pause autoplay
                    carousel.slick('slickGoTo', 0); // Reset to first slide
                }
            });
        }, {
            threshold: 0.5 // Trigger when 50% of carousel is visible
        });

        // Observe the carousel element
        observer.observe(carousel[0]);

        // Cleanup when needed (e.g., if using in a SPA)
        return () => {
            observer.disconnect();
            carousel.slick('unslick');
        };
    }

    if ($('.image-carousel')[0])
        initCarousel();

    document.querySelectorAll('.page-content .content-image-block')
        .forEach((block, index, array) => {
            if (index === array.length - 1) {
                block.classList.add('last');
            }
        });

    $('.testimonial-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        arrows: true,
        once: true,
        dots: true,
        adaptiveHeight: true,
        mobileFirst: true
    });


    // $('.post-area h2,.post-area h3').addClass('aos-animate');
    $('.post-area h2,.post-area h3,.section-header .secondary-title').attr('data-aos', 'fade-up');


    $('.section-header .sub-header').attr({
        'data-aos': 'fade-up',
        'data-aos-delay': '100',
        'data-aos-offset': '200',
        'data-aos-easing': 'ease-in-out'
    });

    $('.blog-posts .post-card').each(function (index) {
        // Reset the delay after every third card
        const delay = (index % 3 + 1) * 100;

        $(this)
            .addClass('aos-animate') // Add the class 'aos-animate'
            .attr('data-aos', 'fade-up') // Set data-aos="fade-up"
            .attr('data-aos-delay', delay); // Set data-aos-delay with resetting value
    });

    AOS.init({
        offset: 0,
        duration: 300,
        easing: 'ease-in-sine',
        delay: 100,
    });
// Append the HTML snippet directly to the #menu-main div


// Handle both forms with the custom-form class
    $('.custom-form').on('submit', function (e) {
        e.preventDefault();
        const form = $(this);
        const formId = form.attr('id'); // 'early_access' or 'webinar_register'
        let errors = [];

        // Reset error states for this form only
        form.find('.hs-form-field').removeClass('error');
        form.find('.form-errors').hide().find('.error-list').empty();

        // Validate First Name
        const firstName = form.find('input[name="first_name"]').val().trim();
        if (!firstName) {
            errors.push('First name is required');
            form.find('.hs-firstname').addClass('error');
        }

        // Validate Last Name
        const lastName = form.find('input[name="last_name"]').val().trim();
        if (!lastName) {
            errors.push('Last name is required');
            form.find('.hs-lastname').addClass('error');
        }

        // Validate Email
        const email = form.find('input[name="email"]').val().trim();
        if (!email) {
            errors.push('Email is required');
            form.find('.hs-email').addClass('error');
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errors.push('Please enter a valid email address');
            form.find('.hs-email').addClass('error');
        }

        // Validate Consent
        if (!form.find('#consent').is(':checked')) {
            errors.push('You must agree to the terms');
            form.find('.hs-consent').addClass('error');
        }

        // Validate Phone (optional)
        const phone = form.find('input[name="phone"]').val().trim();
        if (phone) {
            // Remove all non-digit characters except leading +
            const cleanedPhone = phone.replace(/[^\d+]/g, '');

            // Check E.164 format
            if (!/^\+[1-9]\d{1,14}$/.test(cleanedPhone)) {
                errors.push('Phone must be in the following format (e.g. +12025551234) - include country code');
                form.find('.hs-phone').addClass('error');
            }
            // Check length requirements
            else if (cleanedPhone.length < 8) {  // Minimum: +1 + 6 digits
                errors.push('Phone number too short (include country code and full number)');
                form.find('.hs-phone').addClass('error');
            } else if (cleanedPhone.length > 15) {  // E.164 maximum
                errors.push('Phone number too long (max 15 digits including country code)');
                form.find('.hs-phone').addClass('error');
            }
            // Check for valid country code patterns
            else {
                const countryCode = cleanedPhone.match(/^\+\d{1,3}/)[0];
                const numberPart = cleanedPhone.substring(countryCode.length);

                if (numberPart.length < 5) {  // Most countries require at least 5 digits
                    errors.push('Local number portion too short');
                    form.find('.hs-phone').addClass('error');
                }
            }
        }

        // Display errors if any
        if (errors.length > 0) {
            const errorList = form.find('.error-list');
            errors.forEach(function (error) {
                errorList.append($('<li>').text(error));
            });
            form.find('.form-errors').show();

            // Scroll to errors
            $('html, body').animate({
                scrollTop: form.find('.form-errors').offset().top - 100
            }, 500);
            return;
        }

        // Form is valid - prepare data for Braze
        const formData = {
            action: 'braze_register_user',
            security: brazeVars.nonce,
            form_id: formId,
            first_name: firstName,
            last_name: lastName,
            email: email,
            phone: phone || '',
            consent: form.find('#consent').is(':checked'),
            sms_consent: form.find('[name="sms_consent"]').is(':checked'),
            ...getUTMParams() // Spread the returned UTM params object
        };

        // Show loading state
        const $submitBtn = form.find('input[type="submit"]');
        $submitBtn.prop('disabled', true).val('Processing...');

        // Submit to WordPress AJAX handler
        $.ajax({
            url: brazeVars.ajax_url,
            type: 'POST',
            dataType: 'json',
            data: formData,
            success: function (response) {
                if (response.success) {
                    // Disable button and change text on success
                    $submitBtn.prop('disabled', true).val('Registered!');

                    dataLayer.push({
                        'event': 'braze_event',
                        'event_type': formId, // 'early_access' or 'webinar_register'
                        'email': formData.email,
                        'form_id': formId,
                        'first_name': firstName,
                        'last_name': lastName,
                        'phone': phone || '',
                        'sms_consent': formData.sms_consent,
                        // Include UTM parameters
                        ...getUTMParams()
                    });

                    fbq('track', 'Lead');


                    const url = window.location.href.toLowerCase();
                    const path = window.location.pathname.toLowerCase();

                    // List of patterns to match
                    const patterns = [
                        '/caregiver-resources',
                        '/caregiver-resources/',
                        'caregiver-resources'
                    ];

                    // Check if any pattern matches
                    if (patterns.some(pattern => url.includes(pattern))) {
                        // Redirect with full URL (recommended)
                        const newUrl = new URL('/caregiving-challenges-on-demand/', window.location.origin);
                        window.location.replace(newUrl.href);
                    }

                    // Set up share link tracking if this was webinar registration
                    $('.share-btn').on('click', function () {
                        dataLayer.push({
                            'event': 'braze_event',
                            'event_type': 'share_link',
                            'email': formData.email
                        });

                        $.ajax({
                            url: brazeVars.ajax_url,
                            type: 'POST',
                            data: {
                                action: 'braze_track_event',
                                security: brazeVars.nonce,
                                email: formData.email,
                                event_type: 'share_link'
                            },
                            success: function () {
                                console.log('Share event tracked');
                            }
                        });
                    });



                } else {
                    // Handle error
                    $submitBtn.prop('disabled', false).val('Submit');
                    const errorMsg = response.data?.message || 'Submission failed';
                    form.find('.error-list').html(`<li>${errorMsg}</li>`);
                    form.find('.form-errors').show();
                }
            },
            error: function (xhr) {
                // Handle AJAX error
                $submitBtn.prop('disabled', false).val('Submit');
                form.find('.error-list').html('<li>Network error. Please try again.</li>');
                form.find('.form-errors').show();
                console.error('AJAX error:', xhr.responseText);
            }
        });
    });

    function getUTMParams() {
        const params = new URLSearchParams(window.location.search);
        const utms = {};

        // List of UTM parameters to check
        const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

        utmKeys.forEach(key => {
            const value = params.get(key);
            if (value) utms[key] = value.trim(); // Only add if exists + trim whitespace
        });

        return utms;
    }

// Shared function for tracking Braze events
    function trackBrazeEvent(email, eventType) {
        $.ajax({
            url: brazeVars.ajax_url,
            type: 'POST',
            data: {
                action: 'braze_track_event',
                security: brazeVars.nonce,
                email: email,
                event_type: eventType
            },
            success: function (response) {
                console.log(eventType + ' tracked successfully');
            }
        });
    }
});

$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    var target = $($.attr(this, 'href'));
    if (target.length) {
        var offset = 50; // Adjust this value as needed (in pixels)
        var targetPosition = target.offset().top - offset;

        $('html, body').animate({
            scrollTop: targetPosition
        }, 500);
    }
});
$(document).ready(function () {
    function handleSlider() {
        var windowWidth = $(window).width();
        var breakpoint = 656; // 41em * 16px = 656px

        if (windowWidth < breakpoint) {
            if (!$('.slider-mobile').hasClass('slick-initialized')) {
                $('.slider-mobile').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    mobileFirst: true,
                    adaptiveHeight: true
                });
            }
        } else {
            if ($('.slider-mobile').hasClass('slick-initialized')) {
                $('.slider-mobile').slick('unslick');
            }
        }
    }

    // Initialize on load
    handleSlider();

    // Handle window resize
    $(window).on('resize', function () {
        handleSlider();
    });
});
document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.expandable-section');

    sections.forEach(section => {
        const items = section.querySelectorAll('.expandable-item');

        // Show first item by default
        if (items.length > 0) {
            const firstContent = items[0].querySelector('.expandable-content');
            const firstToggle = items[0].querySelector('.toggle-icon');

            firstContent.classList.add('active');
            firstToggle.textContent = '-';
        }

        // Click handlers
        items.forEach((item, index) => {
            const title = item.querySelector('.expandable-title');
            const content = item.querySelector('.expandable-content');
            const toggle = item.querySelector('.toggle-icon');

            title.addEventListener('click', () => {
                // If clicking the currently active item, close it
                if (content.classList.contains('active')) {
                    content.classList.remove('active');
                    toggle.textContent = '+';
                }
                // Otherwise, close all and open this one
                else {
                    // Close all items
                    items.forEach((i, idx) => {
                        i.querySelector('.expandable-content').classList.remove('active');
                        i.querySelector('.toggle-icon').textContent = '+';
                    });

                    // Open clicked item
                    content.classList.add('active');
                    toggle.textContent = '-';
                }
            });
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    // Animation configuration
    const config = {
        duration: 1500,
        easing: 'easeOutQuad',
        threshold: 0.15,
        finalNumberDelay: 300 // Delay after last count animation before final number starts
    };

    // Easing function
    const easeOutQuad = t => t * (2 - t);

    // Parse number values
    const parseValue = (str) => {
        if (!str) return { value: 0, isPercentage: false };
        const isPercentage = str.includes('%');
        const num = parseFloat(str.replace(/[%,]/g, '')) || 0;
        return { value: num, isPercentage };
    };

    // Format number display
    const formatValue = (num, isPercentage) => {
        const formatted = Math.floor(num).toLocaleString('en-US');
        return isPercentage ? `${formatted}%` : formatted;
    };

    // Animation function that returns a promise
    const animateValue = (el, start, end, isPercentage) => {
        return new Promise(resolve => {
            let startTime = null;

            const animate = (timestamp) => {
                if (!startTime) startTime = timestamp;
                const progress = Math.min((timestamp - startTime) / config.duration, 1);
                const eased = easeOutQuad(progress);
                const current = Math.floor(start + (end - start) * eased);

                el.textContent = formatValue(current, isPercentage);

                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    el.textContent = formatValue(end, isPercentage);
                    resolve();
                }
            };

            requestAnimationFrame(animate);
        });
    };

    // Create observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting || entry.target.dataset.animated) return;
            entry.target.dataset.animated = 'true';

            const block = entry.target;
            const counts = Array.from(block.querySelectorAll('.countup-number, .countdown-number'));
            const finalNumber = block.querySelector('.final-number');

            if (!counts.length && !finalNumber) return;

            // Animate all count numbers sequentially
            const animateCounts = () => {
                let promiseChain = Promise.resolve();

                counts.forEach((el, index) => {
                    promiseChain = promiseChain.then(() => {
                        const isCountdown = el.classList.contains('countdown-number');
                        const parsed = parseValue(el.textContent);
                        const start = isCountdown ? parsed.value * 1.5 : 0;

                        el.textContent = isCountdown ?
                            `+${formatValue(start, parsed.isPercentage)}` :
                            formatValue(start, parsed.isPercentage);

                        return animateValue(el, start, parsed.value, parsed.isPercentage);
                    });
                });

                return promiseChain;
            };

            // Animate final number after all counts complete
            const animateFinal = () => {
                if (!finalNumber) return;

                const parsed = parseValue(finalNumber.textContent);
                finalNumber.textContent = formatValue(0, parsed.isPercentage);

                setTimeout(() => {
                    animateValue(finalNumber, 0, parsed.value, parsed.isPercentage);
                }, config.finalNumberDelay);
            };

            // Execute the full animation sequence
            animateCounts().then(animateFinal);
        });
    }, { threshold: config.threshold });

    // Observe all blocks
    document.querySelectorAll('.animated-section .block-default').forEach(block => {
        observer.observe(block);
    });
});

document.addEventListener('DOMContentLoaded', function() {
    // Configuration
    const config = {
        rolloverDuration: 1000, // Duration of each rollover animation in ms
        delayBetween: 500,      // Delay between rollovers in ms
        threshold: 0.2          // Intersection Observer threshold
    };

    // Track if we've already animated this section
    let hasAnimated = false;

    // Create observer
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting || hasAnimated) return;
            hasAnimated = true;

            const container = entry.target;
            const rolloverBlocks = Array.from(container.querySelectorAll('.block-default.block--rollover'));

            // Function to trigger rollover sequence
            const triggerRolloverSequence = (index = 0) => {
                if (index >= rolloverBlocks.length) {
                    // Reset flag when animation sequence completes
                    setTimeout(() => {
                        hasAnimated = false;
                    }, 2000);
                    return;
                }

                const block = rolloverBlocks[index];

                // Add hover class
                block.classList.add('is-active');

                // After duration, remove hover class
                setTimeout(() => {
                    block.classList.remove('is-active');

                    // Trigger next block after delay
                    setTimeout(() => {
                        triggerRolloverSequence(index + 1);
                    }, config.delayBetween);
                }, config.rolloverDuration);
            };

            // Start the sequence
            triggerRolloverSequence();
        });
    }, { threshold: config.threshold });

    // Observe the blocks container
    const blocksContainer = document.querySelector('.blocks-module');
    if (blocksContainer) {
        observer.observe(blocksContainer);
    }
});